// extracted by mini-css-extract-plugin
export default {"Conteneur":"InterfaceClient_Conteneur__ZWzwT","ConteneurProjet":"InterfaceClient_ConteneurProjet__BDWTL"};